import { render, staticRenderFns } from "./FormErrorText.vue?vue&type=template&id=0b625653&scoped=true&"
import script from "./FormErrorText.vue?vue&type=script&lang=js&"
export * from "./FormErrorText.vue?vue&type=script&lang=js&"
import style0 from "./FormErrorText.vue?vue&type=style&index=0&id=0b625653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b625653",
  null
  
)

export default component.exports